(function(angular){
    'use strict';

    var TmpDmsPermission = (function() {
        var _$inject = ['bmPermission'];

        function TmpDmsPermissionImpl(bmPermission:any) {

            var service = this;

            service.has = function(permission:any) {
                return bmPermission.has(permission).then(function(){
                    return true;
                }).catch(function(){
                    return false;
                });
            };
        }

        TmpDmsPermissionImpl.$inject = _$inject;
        return TmpDmsPermissionImpl;
    }());

    angular.module('onvio.documents').service('tmpDmsPermission', TmpDmsPermission);

})((window as any).angular);
